import * as c from '@chakra-ui/react'
import { useId } from '@chakra-ui/react'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Header from 'src/components/navbar/mobile/items/drawer/header'
import { useAuth } from 'src/pages/auth/auth-context'

import HelpSection from '../../desktop/items/help'
import ButtonLogout from '../../desktop/items/menu-profile/components/button-logout'
import Language from '../../desktop/items/menu-profile/components/language'
import MyProfile from '../../desktop/items/menu-profile/content/my-profile'
import PersonasSection from '../../mobile/items/components/not-logged-links/personas-section'
import { MenuTrigger } from './menuTrigger'

interface Props {
  onToggle: () => void
  onClose: () => void
  isOpen: boolean
}

const MenuDrawerV2 = ({ onToggle, onClose, isOpen }: Props) => {
  const { isAuth } = useAuth()

  const { pathname } = useLocation()
  const drawerId = useId()

  useEffect(() => {
    if (isOpen) onClose()
  }, [pathname])

  return (
    <>
      <MenuTrigger
        onClick={onToggle}
        aria-controls={drawerId}
        aria-expanded={isOpen}
      />
      <c.Drawer
        variant="menu"
        isOpen={isOpen}
        placement="start"
        onClose={onClose}
        size="full"
      >
        <c.DrawerOverlay marginTop="70px" zIndex={88} />
        <c.DrawerContent marginTop="70px" zIndex={88}>
          <c.Flex
            bg="black.0"
            direction="column"
            height="100%"
            overflowY="auto"
            pb="l10"
          >
            <Header />
            <c.Flex direction="column" pt="m7" px="s5" pb="m8" gap="s6">
              <c.Flex direction="column">
                <Language />
                <MyProfile isLogged={isAuth} />
                <ButtonLogout isLogged={isAuth} />
              </c.Flex>
              <PersonasSection isLogged={isAuth} />
              <HelpSection isLogged={isAuth} />
            </c.Flex>
          </c.Flex>
        </c.DrawerContent>
      </c.Drawer>
    </>
  )
}

export default MenuDrawerV2
